/**
 * Bo'lim ichidagi ko'rinish almashtirgich (redesign v2): Drivers -- "Ro'yxat | Doska", Carriers -- "Carrier'lar | Vakansiyalar".
 * Chap menyuda hamma rolda hamma bo'lim yo'q (owner'da Pipeline va Jobs yo'q): sahifaning o'zi qo'shnisiga olib boradi.
 */
import { useLocation, useNavigate } from "react-router";
import type { LucideIcon } from "lucide-react";
import { Segmented } from "@/components/ui/segmented";

export interface SectionSwitchItem {
  to: string;
  label: string;
  icon?: LucideIcon;
}

export function SectionSwitch({ items, ariaLabel, className }: { items: SectionSwitchItem[]; ariaLabel: string; className?: string }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const active = items.find((i) => pathname === i.to || pathname.startsWith(i.to + "/"))?.to ?? items[0].to;
  return (
    <Segmented<string>
      ariaLabel={ariaLabel}
      className={className}
      value={active}
      onChange={(to) => navigate(to)}
      options={items.map((i) => ({ value: i.to, label: i.label, icon: i.icon }))}
    />
  );
}
